import React from "react";
import { dateFormat, utcDateTimeWithTimeZoneWithFormat } from "../../../services/Util";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Constants from "../../../Constants";
import { useTranslation } from "react-i18next";
export default function UserAlert(prop) {
  var alerts = prop.alerts.alertTypeCount;
  const { t } = useTranslation();
  const translate = t;
  const projectDetailResource = prop.projectDetail.resource.projectResource
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  var alertArray = []
  if (alerts.PROJECT_DELIVERY_DEADLINE_WARNING.totalCount > 0) {
    alertArray.push(
      <div className="mar-bot16" key={1}>
        {/* <div className="date">
              <strong>5/16/16</strong>--
              <strong>01:17</strong>
            </div> */}
        <p>
          Language delivery deadline (
          {dateFormat(prop.alerts.dueDate,Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS,custBootstrapDataRedux.user?.timeZone)})
        </p>
        <div className="links">
          {" "}
          {projectDetailResource.projectVendorType === "INTERNAL" ? (
            <Link to="" onClick={()=>prop.redirect('chat')}>Message Internal Translator</Link>
          ) : (
            <Link to="" onClick={()=>prop.redirect('chat')}>Message Internal Translator</Link>
          )}
        </div>
      </div>
    );
  }
  if (alerts.LANGUAGE_REVIEW_TASK_DUE_WARNING.totalCount > 0) {
    alertArray.push(
      <div className="mar-bot16" key={2}>
        <p>
          Review task deadline :{" "}
          {alerts.LANGUAGE_REVIEW_TASK_DUE_WARNING.totalCount} (
          {alerts.LANGUAGE_REVIEW_TASK_DUE_WARNING.overdueAlertCount > 0
            ? alerts.LANGUAGE_REVIEW_TASK_DUE_WARNING.overdueAlertCount +
              " past due"
            : alerts.LANGUAGE_REVIEW_TASK_DUE_WARNING.nearDueAlertCount > 0
            ? alerts.LANGUAGE_REVIEW_TASK_DUE_WARNING.nearDueAlertCount +
              " due soon"
            : ""}
          )
        </p>
        <div className="links">
          {" "}
          <Link onClick={()=>prop.redirect('tasks')} to="">View Task</Link>
        </div>
      </div>
    );
  }
  if (alerts.CLOSE_PROJECT_PENDING_WARNING.totalCount > 0) {
    alertArray.push(
      <div className="mar-bot16" key={3}>
        <p>Project close pending {prop.alerts.dueDate ? '('+utcDateTimeWithTimeZoneWithFormat(prop.alerts.dueDate,Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS,custBootstrapDataRedux.user?.timeZone)+")" : ''}</p>
        {projectDetailResource.projectVendorType === "INTERNAL" ? (
          <Link onClick={()=>prop.redirect('chat')} to="">Message Internal Translator</Link>
        ) : (
          <Link onClick={()=>prop.redirect('chat')} to="">Message Vendor</Link>
        )}
      </div>
    );
  }
  if (alerts.PROJECT_BID_SELECTION_DEADLINE_WARNING.totalCount > 0) {
    alertArray.push(
      <div className="mar-bot16" key={4}>
        <p>
        {translate("user_alert.label_project_bid_selection_deadline")} :{" "}
          {alerts.PROJECT_BID_SELECTION_DEADLINE_WARNING.totalCount} (
          {alerts.PROJECT_BID_SELECTION_DEADLINE_WARNING.overdueAlertCount > 0
            ? alerts.PROJECT_BID_SELECTION_DEADLINE_WARNING.overdueAlertCount +
              " past due"
            : alerts.PROJECT_BID_SELECTION_DEADLINE_WARNING.nearDueAlertCount >
              0
            ? alerts.PROJECT_BID_SELECTION_DEADLINE_WARNING.nearDueAlertCount +
              " due soon"
            : ""}
          )
        </p>
        <div className="links">
          {" "}
          <Link to="/task/OPEN/all/false">View Task</Link>
        </div>
      </div>
    );
  }
  if (alerts.INCOMPLETE_TASK_DUE_WARNING.totalCount > 0) {
    alertArray.push(
      <div className="mar-bot16" key={5}>
        {/* <div className="date">
              <strong>5/16/16</strong>--
              <strong>01:17</strong>
            </div> */}
        <p>
          Custom task deadline : {alerts.INCOMPLETE_TASK_DUE_WARNING.totalCount}{" "}
          (
          {alerts.INCOMPLETE_TASK_DUE_WARNING.overdueAlertCount > 0
            ? alerts.INCOMPLETE_TASK_DUE_WARNING.overdueAlertCount + " past due"
            : alerts.INCOMPLETE_TASK_DUE_WARNING.nearDueAlertCount > 0
            ? alerts.INCOMPLETE_TASK_DUE_WARNING.nearDueAlertCount + " due soon"
            : ""}
          )
        </p>
        <div className="links">
          {" "}
          <Link onClick={()=> prop.funct('tasks')}>View Task</Link>
        </div>
      </div>
    );
  }
  return alertArray
}
